import styled from "styled-components";

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : "100%")};
  #login-form {
    display: flex;
    flex-direction: column;
  }
  #login-privacy-policy-link {
    font-size: 1.6rem;
    text-align: center;
    & > a {
      color: var(--color-black);
    }
  }
  .infoCard {
    border: 1px solid #d6b06d;
    border-radius: 0.5rem;
    padding: 1rem;
  }
  .pageSubTitle {
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 12px;
    text-align: center;
  }
  .content {
    display: flex;
    align-content: center;
    align-items: center;
    color: #d6b06d;
    display: flex;
    text-align: -webkit-match-parent;
  }
  .heading {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .heading2 {
    display: flex;
    justify-content: center;
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: 400;
    color: #565f6b;
  }
  .form-input {
    margin-left: 37px;
    margin-right: 37px;
    color: #000;
  }
  .edit-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: right;
    cursor: pointer;
  }
  .otp-box {
    margin-left: 50px;
    margin-right: 50px;
    margin-top: 15px;
  }
  .resnd-otp-row {
    display: flex;
    justify-content: center;
    color: #717171;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 10px;
    align-items: center;
  }
  .resend-otp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .timer-img {
    height: 15px;
    width: 15px;
    justif-content: center;
    margin-right: 4px;
  }
  .features-box {
    background-color: #ae8e68;
    display: flex;
    flex-direction: column;
    color: white;
    padding-bottom: 10px;
  }
  .features-box-heading {
    font-size: 24px;
    margin-left: 50px;
  }
  .features-box-content {
    font-size: 14px;
    margin-left: 30px;
  }
  .privacy-policy {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
  .display-message {
    display: flex;
    justify-content: center;
    color: #717171;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .broadLine {
    background: #e7e7e7;
    height: 4px;
    margin-top: 10px;
  }
  .icon {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    // border: 1px solid #d6b06d;
    border-radius: 50%;
    font-size: 5rem;
  }
  .message {
    color: #b78115;
    font-size: 1.5rem;
    padding: 2px 10px;
  }
  /* Add only if screen size is greater than 992px */
  @media screen and (min-width: 992px) {
      .form-input{
        margin: 0 auto;
        width: 400px;
      }
  }  

`;
